/*
 * eventbus singleton to distribute events across the whole app
 */
import Vue from 'vue';

const bus = new Vue();

export default bus;
